import { GOOGLE_KEY } from 'utils/constants';

export const reCaptcha = () => {
  const reCaptchaJS = document.createElement('script');
  reCaptchaJS.src = `https://www.google.com/recaptcha/api.js?render=${GOOGLE_KEY}`;
  reCaptchaJS.async = true;
  reCaptchaJS.id = 'reCaptcha-id';
  document.body.appendChild(reCaptchaJS);
};